import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import VueLazyload from 'vue-lazyload';
import '/theme.css';

//import Vue3Mq from 'vue3-mq';

const app = createApp(App);

// Utilisation du router
app.use(router);

// Utilisation de vue-lazyload pour le chargement des images
app.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/error.jpg'), // Image à afficher en cas d'erreur
  loading: require('@/assets/loading.gif'), // Image à afficher pendant le chargement
  attempt: 1 // Nombre de tentatives de chargement
});

/* Utilisation de vue3-mq pour la gestion des points de rupture
app.use(Vue3Mq, {
  breakpoints: {
    mobile: 768, // Taille maximale pour mobile
    tablet: 1024, // Taille maximale pour tablette
    desktop: Infinity // Taille pour desktop
  }
});
*/
// Montage de l'application Vue
app.mount('#app');
